import './nav.css'
import React, {useEffect, useState, useRef} from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { useLang } from '../hook/UseLang.js';
import CONTENT from '../contents/nav'
import '../App.css'
import './nav.css'
//
import LogoWhite from '../svgs/LogoWhite.js'
const HEADERS = {
    home: [],
    concept:[{titleKey:'sightsee',aPath:CONTENT.sightsee.en},{titleKey:'htgt',aPath:CONTENT.htgt.en}],
    rooms:[{titleKey:'amenity',aPath:CONTENT.amenity.en}],
    facility:[{titleKey:'nearBy',aPath:CONTENT.nearBy.en},{titleKey:'otherInfo',aPath:CONTENT.otherInfo.en}],
    news:[{titleKey:'nat',aPath:CONTENT.nat.en}],
    reservation:[{titleKey:'reservation',aPath:CONTENT.reservation.en}],
}
const BottomHeaders = [
    {title:'contact', aPath:CONTENT.contact.en},
    {title:'faq', aPath:CONTENT.faq.en},
    {title:'pp', aPath:CONTENT.pp.en},
]
function Component({rightNav, handleSetRightNav}) {
  const [delayNav, setDelayNav] = useState(false)
  const [lang, setLang] = useLang()
  const navigate = useNavigate();
  const location = useLocation()
  const navRef = useRef()

    useEffect(() => {
        let timer = undefined
        if(!rightNav){
            timer = setTimeout(() => setDelayNav(rightNav), 500)
            setTimeout(() => {
                if(navRef.current)navRef.current.style.display = 'none'
            },500)
        }else{
            if(navRef.current)navRef.current.style.display = 'flex'
            setDelayNav(rightNav)
        }
    },[rightNav])
  function navigating(str){
    // setCurScreen(str)
    handleSetRightNav(false)
    navigate(str)
  }


  if(!delayNav) return <></>
  return (
    <div className={'fixed top-0 left-0 w-[100vw] h-[100vh] bg-[#0FBAB5] overflow-y-auto ' + (rightNav ? 'fade-in-me' : 'fade-out-me')} style={{zIndex:999999}} onClick={() => handleSetRightNav(false)}>
            <div className='w-full h-[103px] flex justify-start items-center d-px48-m-pr48' style={{zIndex:99999}}>
                    <div className='flex flex-row items-center justify-between p-8 cursor-pointer select-none' onClick={() => handleSetRightNav(false)}>
                        <div className='flex flex-col items-center justify-center w-[44px] cursor-pointer select-none h-[11px] relative'>
                            <div className='h-[1px] w-full bg-white absolute top-0 fly-down'></div>
                            <div className='h-[1px] w-full bg-white'></div>
                            <div className='h-[1px] w-full bg-white absolute top-100 fly-up'></div>
                        </div>
                    </div>
            </div>
            <div className='w-full flex flex-row-col items-center justify-center'>
                <div className='flex flex-row items-center justify-center cursor-pointer' style={{flex:0.7}}>
                    <span className='w-[20%] md:w-[20%]' onClick={() => navigating('/')}>
                        <LogoWhite />
                    </span>
                </div>
                <div className='flex flex-col items-start-center' style={{flex:1}}>
                    <div className='w-[70%] grid-container'>
                        {Object.keys(HEADERS).map((key, index) => {
                            if(key === 'reservation')return (
                                <div key={index} className={'grid-item min-h-[180px]'}>
                                    <a href={`https://book-directonline.com/properties/twentyonewhitfield`} target='_blank' className='text-white text-d-20 cursor-pointer hover:opacity-[.5]'>{CONTENT[key][lang]}</a>
                                    <div className='w-[50px] h-[1px] bg-white my-[12px]'></div>
                                </div>
                            )
                            if(key === 'home')return (
                                <div key={index} className={'grid-item min-h-[180px]'}>
                                    <a href={`/?lang=${lang}`} className='text-white text-d-20 cursor-pointer hover:opacity-[.5]'>{CONTENT[key][lang]}</a>
                                    <div className='w-[50px] h-[1px] bg-white my-[12px]'></div>
                                </div>
                            )
                            return (
                                <div key={index} className={'grid-item min-h-[180px]'}>
                                    <div className='text-white text-d-20 cursor-pointer hover:opacity-[.5]' onClick={()=>{navigating(`/${key.toLowerCase()}?lang=${lang}`)}}>{CONTENT?.[key]?.[lang]}</div>
                                    <div className='w-[50px] h-[1px] bg-white my-[12px]'></div>
                                    {HEADERS[key].map((obj, idx) => (
                                        <a href={`#${obj.aPath}`} onClick={() => navigating(`/${key.toLowerCase()}?lang=${lang}`)} key={key+idx} className='grid-item-subtitle text-white text-d-14 cursor-pointer select-none hover:font-[600]'>{CONTENT[obj.titleKey][lang]}</a>
                                    ))}
                                </div>
                            )
                        })}
                    </div>
                    <div className='flex flex-row flex-wrap items-center justify-start mt-[10vh] w-[60%] px-[20px] bottom_3' style={{gap:50}}>
                        {BottomHeaders.map((obj, i) =>   
                        {
                            if(obj.aPath === 'contact') return <a href={`#${obj.aPath}`} onClick={() => navigating(`/?lang=${lang}`)} key={obj.title+i} className='grid-item-subtitle text-white text-d-14 cursor-pointer select-none hover:font-[600]'>{CONTENT[obj.title][lang]}</a>
                            return <div key={obj.title} onClick={() => navigating('/'+obj.aPath+`?lang=${lang}`)} className='text-white text-d-14 cursor-pointer select-none hover:font-[600]'>{CONTENT[obj.title][lang].split('-').join(' ')}</div>
                        }                      
                        )}
                        {/* <div className='text-white text-d-12 cursor-pointer select-none hover:font-[600]'>contact</div>
                        <div className='text-white text-d-12 cursor-pointer select-none hover:font-[600]'>FAQ</div>
                        <div className='text-white text-d-12 cursor-pointer select-none hover:font-[600]'>privacy policy</div>
                        <div className='text-white text-d-12 cursor-pointer select-none hover:font-[600]'>language</div> */}
                    </div>
                </div>
            </div>

    </div>
  );
}

export default Component